export default class PayAccountPayment {
    OrderId: number = 0;
    PaymentId: number = 0;
    PhoneConfirmationCodeId: number = 0;
    SecurityToken: string = '';
}